









import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsColorPicker',
	components: { DmsWrapper },
	props: {
		value: { type: Number },
	},
	computed: {
		/*
		* Color values in DB are stored in decimal format. Component accepts color in hex format.
		*/
		databaseValueToRgbColor() {
			return this.value ? `#${this.value.toString(16)}` : null;
		},
	},
	methods: {
		/*
		* Color values in DB are stored in decimal format. Component emits hex string with '#' as first character.
		*/
		rgbColorToDatabaseValue(colorString: string) {
			return colorString ? parseInt(colorString.replace('#', ''), 16) : null;
		},
	},
});
